import { forwardRef } from 'react';
import { SelectableCard, SelectableCardGroup } from '@gusto/workbench-formik';
import { CardHeader, Grid, Heading } from '@gusto/workbench';

export const NUMBER_STATES_KEY = 'NUMBER_STATES';

export enum NumberStatesValues {
  ONE = 'one',
  TWO_PLUS = 'two_plus',
}

const NumberStates = forwardRef<HTMLFieldSetElement>((_, ref) => {
  return (
    <SelectableCardGroup
      ref={ref}
      className="question"
      name="numberStates"
      id="numberStates"
      label="How many states will you be running payroll in?"
      helperText="We support growing businesses at any stage."
    >
      <Grid rowGap={3} columnGap={2} maxWidth={632} maxWidthMd="100%">
        <SelectableCard type="radio" aria-label="1 state" value={NumberStatesValues.ONE}>
          <CardHeader>
            <Heading className="answer" level={3}>
              1 state
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard
          type="radio"
          aria-label="2 or more states"
          value={NumberStatesValues.TWO_PLUS}
        >
          <CardHeader>
            <Heading className="answer" level={3}>
              2 or more states
            </Heading>
          </CardHeader>
        </SelectableCard>
      </Grid>
    </SelectableCardGroup>
  );
});

export default NumberStates;
